(() => {
  if (window.vgWelcomePopupInitialized) return;
  window.vgWelcomePopupInitialized = true;

  // Keep the original storage key so changing the offer respects prior dismissals.
  const key = 'vargsten:welcome:FIRST10OFF';
  const read = (storage, name) => {
    try { return window[storage].getItem(name); } catch (_) { return null; }
  };
  const write = (storage, name, value) => {
    try { window[storage].setItem(name, value); } catch (_) {}
  };

  function init(root) {
    root.querySelectorAll('[data-vg-welcome]').forEach(dialog => {
      if (dialog.vgWelcomeCleanup || typeof dialog.showModal !== 'function') return;
      const section = dialog.closest('.shopify-section') || dialog.parentElement;
      const form = dialog.querySelector('form');
      const state = dialog.querySelector('[data-vg-welcome-state]')?.dataset.vgWelcomeState || 'idle';
      const ownResponse = form && window.location.hash === '#' + form.id && ['success', 'error'].includes(state);
      const editor = Boolean(window.Shopify?.designMode);
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const delay = Math.max(0, Number(dialog.dataset.delay) || 8) * 1000;
      let timer;
      let disposed = false;
      let shown = false;
      let previousFocus;

      // Preserve visits recorded by the previous session/seven-day invitation.
      if (!editor && (read('sessionStorage', key + ':seen') === '1' ||
          Number(read('localStorage', key + ':dismissed-until')) > 0)) {
        write('localStorage', key + ':seen', '1');
      }

      function suppressed() {
        return shown || read('localStorage', key + ':seen') === '1' ||
          read('sessionStorage', key + ':seen') === '1' ||
          read('localStorage', key + ':subscribed') === '1' ||
          Number(read('localStorage', key + ':dismissed-until')) > 0;
      }

      function occupied() {
        return document.visibilityState === 'hidden' ||
          document.querySelector('dialog[open], [data-vg-menu][open], .vg-search-panel:not([hidden]), cart-drawer.active') ||
          Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"]')).some(modal =>
            modal !== dialog && modal.getClientRects().length > 0 && window.getComputedStyle(modal).visibility !== 'hidden'
          ) ||
          document.body.style.overflow === 'hidden' ||
          document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      }

      function open(manual = false) {
        if (disposed || dialog.open || (!manual && suppressed()) || occupied()) return false;
        previousFocus = document.activeElement;
        dialog.showModal();
        document.body.classList.add('vg-welcome-open');
        shown = true;
        clearTimeout(timer);
        if (!editor) {
          write('localStorage', key + ':seen', '1');
          write('sessionStorage', key + ':seen', '1');
        }
        // Keep the mobile keyboard closed until the visitor chooses the email field.
        dialog.querySelector('[data-vg-welcome-close]')?.focus({ preventScroll: true });
        return true;
      }

      function schedule(wait, response = false) {
        const deadline = Date.now() + wait + 60000;
        const attempt = () => {
          if (disposed || dialog.open || (!response && suppressed())) return;
          if (!open(response) && Date.now() < deadline) timer = setTimeout(attempt, 1000);
        };
        timer = setTimeout(attempt, wait);
      }

      dialog.querySelectorAll('[data-vg-welcome-close]').forEach(button => {
        button.addEventListener('click', () => dialog.close(), options);
      });
      dialog.addEventListener('close', () => {
        document.body.classList.remove('vg-welcome-open');
        if (!disposed && previousFocus?.isConnected && previousFocus !== document.body) {
          previousFocus.focus({ preventScroll: true });
        }
      }, options);

      document.addEventListener('click', event => {
        const trigger = event.target.closest?.('[data-vg-welcome-open]');
        if (!trigger) return;
        // Explicit clicks reopen the offer even after a previous visit or dismissal.
        // Focus the button first so a previously focused input cannot block it.
        trigger.focus({ preventScroll: true });
        if (open(true)) event.preventDefault();
      }, options);

      const message = (key, fallback) => (dialog.dataset[key] || fallback).replace(/\{\{\s*code\s*\}\}|__code__/g, () => code?.value || '');
      const copy = dialog.querySelector('[data-vg-welcome-copy]');
      const code = dialog.querySelector('[data-vg-welcome-code]');
      const status = dialog.querySelector('[data-vg-welcome-status]');
      copy?.addEventListener('click', async () => {
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code.value);
          if (disposed) return;
          copy.textContent = message('copied', 'Copied');
          if (status) status.textContent = message('copiedMessage', 'Code copied. Use {{ code }} at checkout.');
        } catch (_) {
          if (disposed) return;
          code.focus();
          code.select();
          if (status) status.textContent = message('copyFallback', 'Select and copy {{ code }}, then use it at checkout.');
        }
      }, options);

      // Leave submission to Shopify, including validation and any CAPTCHA challenge.
      // Only Shopify's returned form state confirms signup; a click is not success.
      if (ownResponse && state === 'success' && !editor) write('localStorage', key + ':subscribed', '1');
      if (ownResponse) schedule(0, true);
      else if (!editor && state === 'idle' && dialog.dataset.auto !== 'false' && !suppressed()) schedule(delay);

      section.addEventListener('shopify:section:select', () => { if (editor) open(true); }, options);
      section.addEventListener('shopify:section:deselect', () => { if (editor && dialog.open) dialog.close(); }, options);
      dialog.vgWelcomeCleanup = () => {
        disposed = true;
        clearTimeout(timer);
        if (dialog.open) dialog.close();
        document.body.classList.remove('vg-welcome-open');
        controller.abort();
        delete dialog.vgWelcomeCleanup;
      };
    });
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-vg-welcome]').forEach(dialog => dialog.vgWelcomeCleanup?.());
  });
  init(document);
})();
